module.exports = __webpack_public_path__ + "static/media/get-involved--data-party.55e06914.png";